<div id="remarks" data-cy="remarks">
  <div [formGroup]="control" class="form">
    <ife-title
      [title]="'modules.evcQuote.steps.personalDetails.steps.remarks.title' | translate"
      [subtitle]="'modules.evcQuote.steps.personalDetails.steps.remarks.description' | translate"
      data-cy="remarks-title"
    ></ife-title>

    <div class="max-w-4xl mx-auto">
      <div class="form-element textarea">
        <textarea
          id="remarksTextArea"
          class="h-72"
          formControlName="value"
          [placeholder]="'modules.evcQuote.steps.personalDetails.steps.remarks.placeholder' | translate"
          data-cy="remarks-input"
        >
        </textarea>
      </div>
    </div>

    <ife-navigation [showNext]="true" [showPrevious]="true" (nextStep)="navigate()" (previousStep)="navigateBack()">
    </ife-navigation>
  </div>
</div>
